import * as THREE from 'three';

import { renderManager } from './globals.js';



// Añadir superficies de agua (más azul y menos translúcido)
export function agregar_agua(scene, terrainMesh, agua) {

  const terrainBox = new THREE.Box3().setFromObject(terrainMesh);
  const size = new THREE.Vector3();
  terrainBox.getSize(size);
  const center = new THREE.Vector3();
  terrainBox.getCenter(center);

  // =========================================================
  // COLOR AZUL INTENSO
  // =========================================================
  const colorAzul = 0x0F8CEB; // más azul, más profundo

  // =========================================================
  // MATERIAL SUPERIOR (visible)
  // =========================================================
  const aguaMaterialFront = new THREE.MeshStandardMaterial({
    color: colorAzul,
    transparent: true,
    opacity: 0.55,   // ← menos translúcido
    roughness: 0.32,
    metalness: 0.0,
    side: THREE.FrontSide
  });

  // =========================================================
  // MATERIAL INFERIOR (invisible)
  // =========================================================
  const aguaMaterialBack = new THREE.MeshStandardMaterial({
    color: colorAzul,
    transparent: true,
    opacity: 0.0,    // completamente invisible
    roughness: 0.5,
    metalness: 0.0,
    side: THREE.BackSide
  });

  // =========================================================
  // PLANO DE AGUA
  // =========================================================
  const aguaGeometry = new THREE.PlaneGeometry(size.x, size.z);

  // Frente visible
  agua = new THREE.Mesh(aguaGeometry, aguaMaterialFront);
  agua.rotation.x = -Math.PI / 2;
  agua.position.set(center.x, renderManager.surfaceY, center.z);
  agua.raycast = () => {};
  scene.add(agua);

  // Parte inferior invisible
  renderManager.aguaBack = new THREE.Mesh(aguaGeometry, aguaMaterialBack);
  renderManager.aguaBack.rotation.x = -Math.PI / 2;
  renderManager.aguaBack.position.set(center.x, renderManager.surfaceY, center.z);
  renderManager.aguaBack.raycast = () => {};
  scene.add(renderManager.aguaBack);

  // =========================================================
  // (Eliminada) PARED FRONTAL DE AGUA
  // =========================================================
}








export function agregar_muros(terrainMesh, scene, opciones = {}) {

  if (!terrainMesh || renderManager.surfaceY === null) return;
  terrainMesh.updateWorldMatrix(true, true);

  const terrainBox = new THREE.Box3().setFromObject(terrainMesh);
  const min = terrainBox.min.clone();
  const max = terrainBox.max.clone();
  const size = new THREE.Vector3().subVectors(max, min);
  const center = new THREE.Vector3().addVectors(min, max).multiplyScalar(0.5);

  /* Altura muros (TODOS IGUALES) */
  const muroHeight = renderManager.surfaceY - min.y;
  const centerY = min.y + muroHeight / 2;

  /* Material azul agua */
  const sideWallMaterial = new THREE.MeshStandardMaterial({
    color: 0x0066ff,
    transparent: true,
    opacity: 0.4,
    metalness: 0.1,
    roughness: 0.5,
    side: THREE.DoubleSide
  });

  /* ===========================
     MURO TRASERO (Z MIN)
     =========================== */
  const muroTrasero = new THREE.Mesh(
    new THREE.PlaneGeometry(size.x, muroHeight),
    sideWallMaterial
  );
  muroTrasero.position.set(center.x, centerY, min.z);
  muroTrasero.rotation.y = 0;
  scene.add(muroTrasero);

  /* ===========================
     MURO FRONTAL (Z MAX)
     =========================== */
  const muroFrontal = new THREE.Mesh(
    new THREE.PlaneGeometry(size.x, muroHeight),
    sideWallMaterial
  );
  muroFrontal.position.set(center.x, centerY, max.z);
  muroFrontal.rotation.y = Math.PI;
  scene.add(muroFrontal);

  /* ===========================
     MURO IZQUIERDO (X MIN)
     =========================== */
  const muroIzq = new THREE.Mesh(
    new THREE.PlaneGeometry(size.z, muroHeight),
    sideWallMaterial
  );
  muroIzq.position.set(min.x, centerY, center.z);
  muroIzq.rotation.y = Math.PI / 2;
  scene.add(muroIzq);

  /* ===========================
     MURO DERECHO (X MAX)
     =========================== */
  const muroDer = new THREE.Mesh(
    new THREE.PlaneGeometry(size.z, muroHeight),
    sideWallMaterial
  );
  muroDer.position.set(max.x, centerY, center.z);
  muroDer.rotation.y = -Math.PI / 2;
  scene.add(muroDer);


  /* ===========================
     PISO
     =========================== */
  const pisoMaterial = new THREE.MeshStandardMaterial({
    color: 0xDDAC7E,
    roughness: 1,
    metalness: 0,
    side: THREE.DoubleSide
  });

  const piso = new THREE.Mesh(
    new THREE.PlaneGeometry(size.x, size.z),
    pisoMaterial
  );
  piso.rotation.x = -Math.PI / 2;
  piso.position.set(center.x, min.y, center.z);
  scene.add(piso);
}








export function remove_water(elementos) {
  // 1. Filtrar solo los elementos que realmente existen y son objetos
  const elementosValidos = elementos.filter(el => el && typeof el === 'object');

  if (elementosValidos.length === 0) {
    console.warn("remove_water: No se encontraron elementos de agua válidos en este momento.");
    return;
  }

  // 2. Calcular el nuevo estado (toggle)
  // Si al menos uno es visible, pasamos a ocultar todo (false).
  const anyVisible = elementosValidos.some(el => el.visible === true);
  const newVisible = !anyVisible;

  // 3. Cambiar la visibilidad de todos
  elementosValidos.forEach(el => {
    el.visible = newVisible;
  });

  // 4. Cambiar el texto del botón de forma intuitiva
  const button = document.getElementById("water_view_button");
  if (button) {
    // Si están visibles, el botón ofrece "Quitar agua (❌)". Si están ocultos, ofrece "Poner agua (✅)"
    button.innerText = newVisible ? "🌊 ❌" : "🌊 ✅";
  }

  // 5. Notificar al renderizador usando el objeto importado del módulo
  if (renderManager) {
    renderManager.needsRender = true;
  }
}